import {useEffect, useState} from 'react';

import {ValidateInput} from "../../utilities";

function CustomizedRadioButton(props) {
    const {
        label,
        liste_valeurs,
        name,
        required,
        error,
        schema
    } = props

    const [isValid, setIsValid] = useState(!error)

    const validateInput = (e) => {
        const valid = ValidateInput(schema, { [name]: e.target.value })
        setIsValid(valid)
    }

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    const option = liste_valeurs.split(";")

    return <div className={`form-group form-element justify-content-between ${!isValid ? "error" : ""}`}>
        <div>
            <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
        </div>
        <div className='checkbox-container' id={name}>
            {option.map(o => {
                return <div key={o}>
                    <input type="radio" id={`${name}-${o}`} name={name} value={o} onChange={validateInput} />
                    <label htmlFor={`${name}-${o}`}>{o}</label>
                </div>
            })}
        </div>
    </div>
}

export default CustomizedRadioButton;